import axiosForGigbaseBiz from '../config'
import { DataResponse } from '../response'
import { mergeURL } from './lib'
import {
  BranchCandidateTag,
  BranchCandidateTagPayload,
} from 'types/branch_candidate_tag'

const resource = 'branch_candidate_tags'

export const requests = {
  fetchTags: () => {
    return axiosForGigbaseBiz.get<DataResponse<BranchCandidateTag[]>>(resource)
  },

  create: async (params: BranchCandidateTagPayload) => {
    return await axiosForGigbaseBiz.post<DataResponse>(resource, params)
  },

  delete: async (tagId: number) => {
    return await axiosForGigbaseBiz.delete<DataResponse>(
      mergeURL(resource, tagId.toString()),
    )
  },
}
